import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, []);
  const syncInvoice = `syncInvoice(input: ${dataModify})`;
  return gql`
  mutation {
    ${syncInvoice} {
      id
    }
  }
`;
};
